import {Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {KEY_ENTER, KEY_ESC} from '../../../utils';

@Component({
  selector: 'inline-edit',
  templateUrl: './inline-edit.component.html',
  styleUrls: ['./inline-edit.component.scss']
})
export class InlineEditComponent implements OnChanges {

  @Input() value: string;
  @Input() editable = false;
  @Input() block = false;

  @Input() decorator: (value: string) => string;
  @Input() validator: (value: string) => boolean;

  @Output() save = new EventEmitter<string>();

  @ViewChild('field') field: ElementRef;

  editing = false;

  ngOnChanges(changes: SimpleChanges) {
    this.resetContent();
  }

  startEditing() {
    if (this.editable && !this.editing) {
      this.editing = true;
      if (this.decorator)
        this.field.nativeElement[this.block ? 'innerHTML' : 'textContent'] = this.value;
      setTimeout(() => this.field.nativeElement.focus(), 0);
    }
  }

  stopEditing() {
    this.editing = false;
    this.resetContent();
  }

  saveValue() {
    let value = this.field.nativeElement.textContent;
    if (!this.validator || this.validator(value)) {
      this.save.emit(value);
      this.editing = false;
    }
  }

  onKeydown(event: KeyboardEvent) {
    event.stopPropagation();
    if (event.keyCode === KEY_ENTER) {
      if (!this.block || event.ctrlKey) {
        this.saveValue();
      } else {
        document.execCommand('insertHTML', false, '\n');
      }
      event.preventDefault();
    } else if (event.keyCode === KEY_ESC) {
      this.stopEditing();
    }
  }

  private resetContent() {
    let value = this.value;
    if (this.decorator) {
      value = this.decorator(value);
    }
    this.field.nativeElement[this.block ? 'innerHTML' : 'textContent'] = value;
  }
}
